import { AccountTypes } from "@utils";
import { SubmitLimitAction } from "@state/stores/account-settings/my-limits/MyLimitsStore";

export class ResolveLimit {
	amount: number;
	action: number;
	categoryId: string;
	durationId: string;
	typeId: string;
	limitId: string;
}

export class ResolveDepositAndLossLimit {
	//deposit
	amount: number;
	gamingLimitAction: SubmitLimitAction;
	gamingLimitCategoryId: string;
	gamingLimitDurationId: string;
	gamingLimitTypeId: string;
	limitId: string | null;

	//loss
	lossAmount: number;
	lossGamingLimitAction: SubmitLimitAction;
	lossGamingLimitCategoryId: string;
	lossGamingLimitDurationId: string;
	lossGamingLimitTypeId: string;
	lossLimitId: string | null;

	activeGamingLimitCategoryId: string;
}

export class ResolveLimitRequest {
	action: number;
	categoryId: string;
	userLimitId: string;
	userLimitRequestId: string;
}

export class LimitCategoriesViewModel {
	categoryId: string;
	categoryName: string;
	maxAmount: number;
	minAmount: number;
	description: string[];
	durations: UserLimit[] | [];
	isMultiLimitModeEnabled: boolean;
	requests: LimitRequest[];
	infoMessage?: string;
	currency: string;
	isMultiTypeMode: boolean;
	activeCategoryAbrv: string;
	updateInterval: number;
}

export class UserLimit {
	limitId: string;
	name: string;
	canBeUpdated: boolean;
	canBeDeleted: boolean;
	categoryId: string;
	durationId: string;
	typeId: string;
	units: number;
	amount: number | null;
	categoryAbrv: string;
}

export class LimitRequest {
	requestType: string;
	limitType: string;
	requestedAmount: number;
	currentAmount: number;
	categoryId: string;
	requestDate: string;
	expirationDate: string;
	limitId: string;
	requestId: string;
	limitInterval?: string;
	hasLimitAmountChanged?: boolean;
	hasLimitTypeChanged?: boolean;
	hasLimitDurationChanged?: boolean;
	isDeactivation?: boolean;
}

export class LimitSubmit {
	amount: number;
}

export type DepositAndLossLimitSubmit = LimitSubmit & { lossAmount: number };

export class TabModel {
	id: string;
	name: string;
	accountType: AccountTypes;
}

export type LimitTypeItem = {
	abrv: string;
	dateCreated: string;
	dateUpdated: string;
	description?: string;
	id: string;
	name: string;
};

export type TLimitDurationItem = LimitTypeItem & {
	units: number;
};

export class SubmitSingleLimitData {
	amount: number;
	limitDuration: string;
	limitType: string;
}

export enum LimitCategoryTypes {
	GAMES = "games",
	SPORTS_BETTING = "sports-betting",
}

export enum LimitTypes {
	LOSS = "loss",
	DEPOSIT = "deposit",
}
